import * as tslib_1 from "tslib";
import dashboardApi from '@/services/dashboard';
import { timeFormat } from '@/shared/utils';
import { useAntdTable } from 'ahooks';
import { Table } from 'antd';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
const Root = styled.div ``;
const ENV_TYPE_CN_NAME = {
    1: '开发环境',
    2: '测试环境',
    3: '稳定环境',
};
const detailUrlPrefixTest = 'http://f2e.dasouche-inc.net/projects/data-fe/env-manager/#/myenv/';
const detailUrlPrefixPro = 'https://f2e-assets.souche-inc.com/projects/data-fe/env-manager/#/myenv/';
const renderTimeLimit = (text, record) => {
    if (text) {
        let str = '';
        str = moment(record.deadline, ['YYYY', moment.ISO_8601]).format('YYYY-MM-DD');
        return `${text} (${str}到期)`;
    }
    return '-';
};
const renderOwners = (text, record) => {
    if (text) {
        const partnerList = text.split(',').map(item => {
            const [nickname] = item.split('@');
            return nickname;
        });
        return <div>{partnerList.join('、')}</div>;
    }
    return '-';
};
const MyEnv = ({ className, style }) => {
    const columns = [
        {
            title: '环境类型',
            dataIndex: 'envType',
            render: (text) => ENV_TYPE_CN_NAME[text],
            width: '12%',
        },
        {
            title: '环境名称',
            dataIndex: 'envName',
            width: '24%',
            render: (text, record) => {
                return (<a onClick={() => {
                    if (process.env.MUJI_APP_ENV === 'prod') {
                        window.open(`${detailUrlPrefixPro}${record.id}`);
                    }
                    else {
                        window.open(`${detailUrlPrefixTest}${record.id}`);
                    }
                }}>
            {text}
          </a>);
            },
        },
        {
            title: '创建人',
            dataIndex: 'createName',
            width: '10%',
        },
        {
            title: '协作人',
            dataIndex: 'owners',
            width: '20%',
            render: renderOwners,
        },
        {
            title: '创建时间',
            dataIndex: 'createDate',
            width: '16%',
            render: (text) => {
                return moment(text).format(timeFormat.dayFormat);
            },
        },
        {
            title: '有效期',
            width: '18%',
            dataIndex: 'timeLimit',
            render: renderTimeLimit,
        },
    ];
    const getMyEnvPage = (params) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield dashboardApi.fetchMyEnv({
            page: params.current,
            size: params.pageSize,
            isPodReleased: 0,
        }).promise;
    });
    const { tableProps } = useAntdTable(getMyEnvPage, {
        defaultPageSize: 10,
        formatResult: (res) => {
            return {
                total: res.totalNumber,
                list: res.items,
            };
        },
    });
    return (<Root className={className} style={style}>
      <Table columns={columns} {...tableProps} scroll={{ y: 300 }} rowKey={'id'}/>
    </Root>);
};
export default MyEnv;
